import { render, staticRenderFns } from "./InterfaceParam.vue?vue&type=template&id=08a3be6a&scoped=true"
import script from "./InterfaceParam.vue?vue&type=script&lang=js"
export * from "./InterfaceParam.vue?vue&type=script&lang=js"
import style0 from "./InterfaceParam.vue?vue&type=style&index=0&id=08a3be6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a3be6a",
  null
  
)

export default component.exports